module.exports = __webpack_public_path__ + "static/video/adad_hannah_2.6298ca3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/commons/video/adad_hannah_2.mp4
// module id = IN8b
// module chunks = 0